import { Plugins } from '@leverege/plugin';
import ClickActions from "./actions/clickActions/PluginSetup.js";
import AggResultProcessorSetup from "./models/resultsProcessors/PluginSetup.js";
import { AggsSettingsAction, EditAggsContainerSettingsAction } from "./actions/index.js";
import AggregationsXYChartDataViewer from "./AggregationsXYChartDataViewer.js";
import AggregationsPieChartDataViewer from "./AggregationsPieChartDataViewer.js";
import AggregationsDataViewer from "./AggregationsDataViewer.js";
import AggsXYChartSupportDataViewer from "./AggsXYChartSupportDataViewer.js";
import AggsPieChartSupportDataViewer from "./AggsPieChartSupportDataViewer.js";
import AggsViewEditor from "./editors/AggsViewEditor.js";
import AggsViewModel from "./models/AggsViewModel.js";
import AggsListModel from "./shared/AggsListModel.js";
import AggsListEditor from "./shared/AggsListEditor.js";
import { TermsAggModel, TermsAggEditor, FilterAggModel, FilterAggEditor, HistogramAggModel, HistogramAggEditor, StatsAggModel, StatsAggEditor, BucketAggTextViewModel, BucketAggTextViewEditor, BucketAggTextView, AggJSONViewModel, AggJSONView, AggJSONViewEditor, CountAggTextViewModel, CountAggTextView, CountAggTextViewEditor, StatsAggTextViewEditor, StatsAggTextViewModel, StatsAggTextView, RangeAggModel, RangeAggEditor, GeoDistanceAggModel, GeoDistanceAggEditor, GeoDistanceAggTextView, GeoDistanceAggTextViewModel, GeoDistanceAggTextViewEditor, FiltersAggModel, FiltersAggEditor } from "./types/index.js";
import AggKeyAttribute from "./attributes/AggKeyAttribute.js";
import AggValueAttribute from "./attributes/AggValueAttribute.js";
import AggDeviceIdAttribute from "./attributes/AggDeviceIdAttribute.js";
const modelTypes = ['AggModel', 'AggViewModel'];
const editorTypes = ['AggEditor'];
modelTypes.forEach(type => {
  Plugins.on(type, evt => {
    if (evt.type === 'pluginAdded') {
      Plugins.add('Model', evt.plugin);
    }
    if (evt.type === 'pluginRemoved') {
      Plugins.remove('Model', evt.plugin);
    }
  });
});
editorTypes.forEach(type => {
  Plugins.on(type, evt => {
    if (evt.type === 'pluginAdded') {
      Plugins.add('ModelEditor', evt.plugin);
    }
    if (evt.type === 'pluginRemoved') {
      Plugins.remove('ModelEditor', evt.plugin);
    }
  });
});
const install = molten => {
  ClickActions.install(molten);
  molten.addPlugin('Action', AggsSettingsAction);
  molten.addPlugin('Action', EditAggsContainerSettingsAction);
  molten.addPlugin('Model', AggsViewModel);
  molten.addPlugin('ModelEditor', {
    type: AggsViewModel.TYPE,
    editor: AggsViewEditor
  });
  molten.addPlugin('Model', {
    type: AggsListModel.TYPE,
    model: AggsListModel
  });
  molten.addPlugin('ModelEditor', {
    type: AggsListModel.TYPE,
    editor: AggsListEditor
  });
  molten.addPlugin('AggModel', {
    type: TermsAggModel.TYPE,
    name: TermsAggModel.name,
    model: TermsAggModel
  });
  molten.addPlugin('AggEditor', {
    type: TermsAggModel.TYPE,
    editor: TermsAggEditor
  });
  molten.addPlugin('AggModel', {
    type: FilterAggModel.TYPE,
    name: FilterAggModel.name,
    model: FilterAggModel
  });
  molten.addPlugin('AggEditor', {
    type: FilterAggModel.TYPE,
    editor: FilterAggEditor
  });
  molten.addPlugin('AggModel', {
    type: FiltersAggModel.TYPE,
    name: FiltersAggModel.name,
    model: FiltersAggModel
  });
  molten.addPlugin('AggEditor', {
    type: FiltersAggModel.TYPE,
    editor: FiltersAggEditor
  });
  molten.addPlugin('AggModel', {
    type: HistogramAggModel.TYPE,
    name: HistogramAggModel.name,
    model: HistogramAggModel
  });
  molten.addPlugin('AggEditor', {
    type: HistogramAggModel.TYPE,
    editor: HistogramAggEditor
  });
  molten.addPlugin('AggModel', {
    type: StatsAggModel.TYPE,
    name: StatsAggModel.name,
    model: StatsAggModel
  });
  molten.addPlugin('AggEditor', {
    type: StatsAggModel.TYPE,
    editor: StatsAggEditor
  });
  molten.addPlugin('AggModel', {
    type: RangeAggModel.TYPE,
    name: RangeAggModel.name,
    model: RangeAggModel
  });
  molten.addPlugin('AggEditor', {
    type: RangeAggModel.TYPE,
    editor: RangeAggEditor
  });
  molten.addPlugin('AggModel', {
    type: GeoDistanceAggModel.TYPE,
    name: GeoDistanceAggModel.name,
    model: GeoDistanceAggModel
  });
  molten.addPlugin('AggEditor', {
    type: GeoDistanceAggModel.TYPE,
    editor: GeoDistanceAggEditor
  });
  molten.addPlugin('AggViewModel', {
    type: BucketAggTextViewModel.TYPE,
    model: BucketAggTextViewModel
  });
  molten.addPlugin('AggView', {
    type: BucketAggTextViewModel.TYPE,
    view: BucketAggTextView
  });
  molten.addPlugin('AggViewEditor', {
    type: BucketAggTextViewModel.TYPE,
    editor: BucketAggTextViewEditor
  });
  molten.addPlugin('AggViewModel', {
    type: CountAggTextViewModel.TYPE,
    model: CountAggTextViewModel
  });
  molten.addPlugin('AggView', {
    type: CountAggTextViewModel.TYPE,
    view: CountAggTextView
  });
  molten.addPlugin('AggViewEditor', {
    type: CountAggTextViewModel.TYPE,
    editor: CountAggTextViewEditor
  });
  molten.addPlugin('AggViewModel', {
    type: StatsAggTextViewModel.TYPE,
    model: StatsAggTextViewModel
  });
  molten.addPlugin('AggView', {
    type: StatsAggTextViewModel.TYPE,
    view: StatsAggTextView
  });
  molten.addPlugin('AggViewEditor', {
    type: StatsAggTextViewModel.TYPE,
    editor: StatsAggTextViewEditor
  });
  molten.addPlugin('AggViewModel', {
    type: GeoDistanceAggTextViewModel.TYPE,
    model: GeoDistanceAggTextViewModel
  });
  molten.addPlugin('AggView', {
    type: GeoDistanceAggTextViewModel.TYPE,
    view: GeoDistanceAggTextView
  });
  molten.addPlugin('AggViewEditor', {
    type: GeoDistanceAggTextViewModel.TYPE,
    editor: GeoDistanceAggTextViewEditor
  });
  if (process.env.NODE_ENV === 'development') {
    molten.addPlugin('AggViewModel', {
      type: AggJSONViewModel.TYPE,
      model: AggJSONViewModel
    });
    molten.addPlugin('AggView', {
      type: AggJSONViewModel.TYPE,
      view: AggJSONView
    });
    molten.addPlugin('AggViewEditor', {
      type: AggJSONViewModel.TYPE,
      editor: AggJSONViewEditor
    });
  }
  molten.addPlugin('DataViewer', AggregationsDataViewer);
  molten.addPlugin('DataViewer', AggregationsXYChartDataViewer);
  molten.addPlugin('DataViewer', AggsXYChartSupportDataViewer);
  molten.addPlugin('DataViewer', AggregationsPieChartDataViewer);
  molten.addPlugin('DataViewer', AggsPieChartSupportDataViewer);
  AggResultProcessorSetup.install(molten);
  Plugins.add('Attribute', AggKeyAttribute);
  Plugins.add('Attribute', AggValueAttribute);
  Plugins.add('Attribute', AggDeviceIdAttribute);
};
export default {
  install
};